import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UserInfo } from './user-info/UserInfo';
import { Menu } from './menu/Menu';
import { Legal } from './legal/Legal';
import { CurrentUser } from '../../../model/CurrentUser';
import './Sidebar.css';

class SidebarMenu extends React.Component {

    render() {
        const {
            collapsed,
            currentUser,
        } = this.props;

        const classNames = `ps-sidebar ${collapsed ? 'ps-sidebar-collapsed' : ''}`;

        return (
            <div className={classNames}>
                <UserInfo currentUser={currentUser}/>
                <Menu currentUser={currentUser}/>
                <Legal/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: CurrentUser.fromReduxState(state),
    };
};

export const Sidebar = connect(mapStateToProps)(SidebarMenu);

Sidebar.propTypes = {
    collapsed: PropTypes.bool.isRequired,
};

Sidebar.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/Sidebar.jsx